import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { SiQuantcast } from 'react-icons/si';
import { QtyUpdatePickUpApi } from '../Utils/ApiCalls';
import Button from './Button';
import Input from './Input'
import { useNavigate } from 'react-router-dom';

export default function UpdatePickUpQty({ isOpen, onClose,  SingleData, state}) {

    const nav = useNavigate()

    const [Payload, setPayload] = useState({
        qty: ""
    });

    const [Loading, setLoading] = useState(false);

    console.log("singledataaa", SingleData)

    const handleUpdate = (e) => {
        setPayload({ ...Payload, [e.target.id]: e.target.value })
    }

    
    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });

    const UpdateRequest = async ()=>{
        try {
            setLoading(true)
            let result =  await QtyUpdatePickUpApi(Payload, SingleData[0]?._id);

            console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Qty Updated successfully"
                })
              
             
                setPayload({
                   qty: ""
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                    onClose()

                 
                }, 1000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            setTimeout(() => {
                setErrorMsg({
                    status: false,
                    msg: e.message
                })
            }, 5000);
            console.error('Error:', e.message);
        }

    }

    useEffect(() => {
 
        setPayload({
            qty: SingleData[0]?.qtyrequested
        })
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader textTransform={"capitalize"}>Update {SingleData[0]?.productname} Quantity</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={"15px"}>
                        <Input leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='Quantity Requested' id="qty" type='number' value={Payload.qty} val={Payload.qty != "" ? true : false} onChange={handleUpdate} />

                    </Stack>

                    <Button mt="14px" isLoading={Loading}
                        disabled={Payload.qty != "" ? false : true}
                        onClick={UpdateRequest} background="green">Update
                    </Button>



                    
                    {
                        errorMsg.status && (
                            <Text mt={"10px"} color="red" textAlign="center">{errorMsg.msg}</Text>
                        )
                    }

                    {
                        SuccessMsg.status && (
                            <Text mt={"10px"} color="green" textAlign="center">{SuccessMsg.msg}</Text>
                        )
                    }
                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
